import {
	GET_BILLING_CHARACTER_COUNT,
	GET_BILLING_CHARACTER_COUNT_CLEAR,
	GET_BILLING_CHARACTER_COUNT_FAIL,
	GET_BILLING_CHARACTER_COUNT_SUCCESS,
	GET_BILLING_USER_LOGIN_DETAILS,
	GET_BILLING_USER_LOGIN_DETAILS_CLEAR,
	GET_BILLING_USER_LOGIN_DETAILS_FAIL,
	GET_BILLING_USER_LOGIN_DETAILS_SUCCESS,
	SET_PAGE_NUMBER_CHAR_COUNT,
	SET_PAGE_NUMBER_USER_LOGIN_DETAILS,
} from "../types"

export const getCharacterCount = (data) => ({
	type: GET_BILLING_CHARACTER_COUNT,
	payload: data,
})

export const getCharacterCountSuccess = (data) => ({
	type: GET_BILLING_CHARACTER_COUNT_SUCCESS,
	payload: data,
})

export const getCharacterCountFailed = (data) => ({
	type: GET_BILLING_CHARACTER_COUNT_FAIL,
	payload: data,
})

export const getCharacterCountReset = () => ({
	type: GET_BILLING_CHARACTER_COUNT_CLEAR,
})

export const getUserloginDetails = (data) => ({
	type: GET_BILLING_USER_LOGIN_DETAILS,
	payload: data,
})

export const getUserloginDetailsSuccess = (data) => ({
	type: GET_BILLING_USER_LOGIN_DETAILS_SUCCESS,
	payload: data,
})

export const getUserloginDetailsFailed = (data) => ({
	type: GET_BILLING_USER_LOGIN_DETAILS_FAIL,
	payload: data,
})

export const getUserloginDetailsReset = () => ({
	type: GET_BILLING_USER_LOGIN_DETAILS_CLEAR,
})

export const setPageNumberCharCount = (data) => ({
	type: SET_PAGE_NUMBER_CHAR_COUNT,
	payload: data,
})

export const setPageNumberUserLoginDetails = (data) => ({
	type: SET_PAGE_NUMBER_USER_LOGIN_DETAILS,
	payload: data,
})
